import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { AlertAccountSettings } from "./AlertAccountSettings";
import DeviceManagementTableSection from "./DeviceManagementTableSection";
import RecipientTableSection from "./RecipientTableSection";
import AdditionalRecipientTableSection from "./AdditionalRecipientTableSection";
// import SyslogSettingsSection from "../rules/syslog-settings/SyslogSettingsSection";
//import SyslogDestinationTableSection from "./SyslogDestinationTableSection";
import RemoteSyslogServerSection from "../../src/system/remote-syslogserver/RemoteSyslogServerSection";

export function TablesSection() {
    const [collapsed, setCollapsed] = useState(true);

    return (
        <>
            <div className="oct_analysis-card-v2 p-4 m-4">
                <button
                    className="oct_settings-section-header"
                    onClick={() => setCollapsed(!collapsed)}
                >
                    <h3 className="mb-0 text-base font-bold text-slate-800">Email Notifications</h3>
                    <ChevronDown
                        className={`oct_icon oct_settings-chevron-v2 ${!collapsed ? 'oct_expanded' : ''}`}
                    />
                </button>

                <div className={`oct_settings-section-body ${collapsed ? 'oct_collapsed' : 'oct_expanded'}`}>
                    <div className="mt-4">
                        <div className="row">
                            <div className="col-12 col-xl-6 d-flex flex-column oct_column-gap-v2">
                                <AlertAccountSettings />
                                <RecipientTableSection />
                                <AdditionalRecipientTableSection />
                                {/* <SyslogDestinationTableSection /> */}
                            </div>
                            <div className="col-12 col-xl-6 d-flex flex-column mt-4 mt-xl-0 oct_column-gap-v2">
                                <DeviceManagementTableSection />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <SyslogSettingsSection /> */}
            <RemoteSyslogServerSection />
        </>
    )
}